import { render, staticRenderFns } from "./CustomerArtworkDialog.vue?vue&type=template&id=05d5af6b&scoped=true"
import script from "./CustomerArtworkDialog.vue?vue&type=script&lang=js"
export * from "./CustomerArtworkDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerArtworkDialog.vue?vue&type=style&index=0&id=05d5af6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5af6b",
  null
  
)

export default component.exports